import { Button } from '@mui/material'
import { useEffect, useRef } from 'react'
import './LeaderBoardTab.css'

const LeaderBoardTab = ({ onClick, tabData, isCurrentTab }) => {
  const buttonRef = useRef(null)
  let electedData = null
  const savedData = localStorage.getItem('activetab')

  if (savedData) {
    try {
      electedData = JSON.parse(savedData)
    } catch (e) {
      console.error('Error parsing electedData from localStorage:', e)
    }
  }
  if (!electedData) {
    electedData = { id: 10001 }
  }

  useEffect(() => {
    if (tabData?.id == electedData?.id && buttonRef.current) {
      buttonRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    }
  }, [])

  return (
    <Button
      id={`${tabData?.id}_leaderboardtab`}
      ref={buttonRef}
      key={tabData?.id}
      type="button"
      className={
        tabData?.id == electedData?.id
          ? 'btn btn-primary primary-btn mr-3 mt-1 mb-1'
          : 'btn btn-primary normal-btn mr-3 mt-1 mb-1'
      }
      onClick={onClick}
    >
      {tabData?.tabTitle?.length > 35 ? `${tabData?.tabTitle.slice(0, 35)}...` : tabData?.tabTitle}
    </Button>
  )
}

export default LeaderBoardTab
